import { omit } from "lodash";

// Set once, when a todo is created. Editing a todo must not rewrite them:
// saving an edit used to move the created date to the edit time and make the
// editor its creator.
export const TODO_CREATION_FIELDS = ["creation_date_time", "created_by"];

/**
 * What the workflow's Todo List tab sends when its form is submitted.
 *
 * @param {object} params
 * @param {object} params.formValues - values from TodoForm
 * @param {object|null} params.selectedTodo - the todo being edited, or null when creating
 * @param {string} params.caId - workflow id
 * @param {string} params.clientFullName
 * @param {string} params.createdAt - "YYYY-MM-DD HH:mm" in the tenant's timezone; used only when creating
 * @returns {{ todoId: string|null, data: object }} todoId is set when the todo should be updated
 */
export const buildTodoSubmission = ({ formValues, selectedTodo, caId, clientFullName, createdAt }) => {
  const data = { ...formValues, client_appointment_id: caId, client_full_name: clientFullName };
  if (selectedTodo) {
    return { todoId: selectedTodo.id, data: omit(data, TODO_CREATION_FIELDS) };
  }
  return { todoId: null, data: { ...data, creation_date_time: createdAt } };
};
